import script from "./flash-growth-reset.vue?vue&type=script&setup=true&lang=js"
export * from "./flash-growth-reset.vue?vue&type=script&setup=true&lang=js"

import "./flash-growth-reset.vue?vue&type=style&index=0&id=d8c496e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c496e2"]])

export default __exports__